import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@nosible/shared/components/ui/card";

export function AccessDenied() {
  return (
    <div className="flex h-full items-center justify-center">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle className="text-red-400">Access Denied</CardTitle>
          <CardDescription>
            You do not have permission to view this page. Admin access is required.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
